import styled from 'styled-components/macro';

const Main = styled.main`
    height: 100%;
`;

export { Main };
